import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { VehiclesState } from './types'

const INITIAL_STATE: VehiclesState = {
  error: '',
  hasFinish: false,
  list: [],
  loading: false,
  message_id: [],
  originalFullRequestVehiclesHistory: null
}

const reducer = createReducer<VehiclesState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getVehicles, () => ({
    ...INITIAL_STATE,
    loading: true
  }))
  .handleAction(Actions.getVehiclesFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    hasFinish: true,
    loading: false
  }))
  .handleAction(
    Actions.getVehiclesSuccess,
    (state, { payload: { list, message_id } }) => ({
      ...state,
      hasFinish: true,
      list,
      loading: false,
      message_id
    })
  )
  .handleAction(Actions.getVehiclesHistory, () => ({
    ...INITIAL_STATE,
    loading: true
  }))
  .handleAction(Actions.getVehiclesHistoryFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    hasFinish: true,
    loading: false
  }))
  .handleAction(
    Actions.getVehiclesHistorySuccess,
    (state, { payload: { originalFullRequestVehiclesHistory } }) => ({
      ...state,
      hasFinish: true,
      loading: false,
      originalFullRequestVehiclesHistory
    })
  )
  .handleAction(Actions.resetVehicles, () => ({
    ...INITIAL_STATE
  }))

export default reducer
